import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from 'reactstrap';

import { PathsLayouts } from '../../../../config/routes';
import { TranslationsKeys } from '../../../../locales/translations';
import { ContinuousEducationType } from '../types';

export function CreateOfferButton() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );
  const history = useHistory();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleCreateCourse = () => {
    history.push(
      `${PathsLayouts.continuousEducation}/academic-offers/new/wizard?programType=${ContinuousEducationType.COURSE}`,
    );
  };

  const handleCreateProgram = () => {
    history.push(
      `${PathsLayouts.continuousEducation}/academic-offers/new/wizard?programType=${ContinuousEducationType.PROGRAM_COURSE}`,
    );
  };

  return (
    <Row className="mb-4">
      <Col xs={12} md={6} lg={3} className="offset-md-6 offset-lg-9">
        <Dropdown
          isOpen={dropdownOpen}
          toggle={toggle}
          style={{ width: '100%' }}
        >
          <DropdownToggle
            className="g-button text-uppercase"
            color="primary"
            size="md"
            caret
            style={{ width: '100%' }}
          >
            <span>{t('create.button')}</span>
          </DropdownToggle>
          <DropdownMenu end style={{ minWidth: '100%' }}>
            <DropdownItem onClick={handleCreateCourse}>
              {t('create.options.course')}
            </DropdownItem>
            <DropdownItem onClick={handleCreateProgram}>
              {t('create.options.program')}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Col>
    </Row>
  );
}
